import { useEffect, useState } from "react";
import { Typography } from "antd";
import { StepUpModal } from "./StepUpModal.js";
import { subscribeStepUp, type StepUpRequest } from "../auth/step-up-controller.js";

// Human labels for the scopes we prompt on. Fallback = a generic title, so a new sensitive scope
// still works (just with plainer copy) without touching this map.
const SCOPE_LABEL: Record<string, string> = {
  "write:giftme:discountProviders": "Save discount provider",
};

/** Mounted once at app root. Listens for step-up challenges raised by the transport layer and drives
 *  the shared OTP modal, resolving the controller with the fresh scoped token (or rejecting on cancel). */
export function StepUpHost() {
  const [req, setReq] = useState<StepUpRequest | null>(null);
  useEffect(() => subscribeStepUp(setReq), []);

  const title = req ? (SCOPE_LABEL[req.scope] ?? "Confirm sensitive action") : "";
  return (
    <StepUpModal
      open={!!req}
      title={title}
      scope={req?.scope ?? ""}
      confirmLabel="Confirm"
      intro={<Typography.Paragraph type="secondary">This is a sensitive action — confirm with a fresh code sent to your phone.</Typography.Paragraph>}
      onClose={() => req?.reject(new Error("step_up_cancelled"))}
      onDone={() => { /* run() already resolved the request; nothing to do */ }}
      run={async (token) => { req?.resolve(token); }}
    />
  );
}
